import { defaultAggProps } from "./index60.js";
import { isLineOnEdges } from "./index61.js";
function getAdjacencyWeightMod({ plotEdges, adjacencyFactor = defaultAggProps.adjacencyFactor }) {
	return (lines) => {
		const weights = lines.map((line) => getLineWeight(line, plotEdges, adjacencyFactor));
		if (weights.every((w) => w === 0)) return Array(lines.length).fill(1);
		return weights;
	};
}
function getLineWeight(line, plotEdges, siteBoundaryFactor) {
	if (!isLineOnEdges(line, plotEdges)) return 1;
	return 1 - siteBoundaryFactor;
}
export { getAdjacencyWeightMod };

//# sourceMappingURL=index62.js.map